import { createFileRoute } from "@tanstack/react-router";
import {
  createStructuredDataScript,
  generateWebPageStructuredData,
  seo,
  SEO_SITE_URL,
} from "@/lib/utils/seo";
import { RingHistoryPage } from "@/features/game/ring/ring-history-page";
import { getMyRingGameHistory } from "@/lib/client/ring-game";

export const Route = createFileRoute("/_index/game/ring-history")({
  component: RouteComponent,
  async loader({ context }) {
    if (!context.user) {
      return { history: null };
    }

    const history = await getMyRingGameHistory();
    return { history };
  },
  head: () => ({
    meta: [
      ...seo({
        title: "Apex 猜圈历史记录 | CN Apex Club",
        description: "查看你的 Apex 猜圈历史成绩与游戏记录。",
        keywords: "Apex Legends,猜圈历史,游戏记录,成绩记录,CN Apex Club",
        url: `${SEO_SITE_URL}/game/ring-history`,
        type: "website",
        noindex: true,
        nofollow: true,
      }),
    ],
    scripts: [
      createStructuredDataScript(
        generateWebPageStructuredData({
          name: "Apex 猜圈历史记录",
          description: "查看你的 Apex 猜圈历史成绩与游戏记录。",
          url: `${SEO_SITE_URL}/game/ring-history`,
        }),
      ),
    ],
  }),
});

function RouteComponent() {
  const { history } = Route.useLoaderData() as {
    history: Awaited<ReturnType<typeof getMyRingGameHistory>> | null;
  };
  const { user } = Route.useRouteContext();

  return <RingHistoryPage currentUser={user} history={history} />;
}
